import { DashboardCount, GetAllThumbnail, CompanySitedetails } from "../Constants/DashboardCount"


export const getDashboardCount = (dashboard) => {
    return {
        type: DashboardCount.GET_DASHBOARDCOUNT,
        payload: dashboard
    };
};
export const getThumbnail = (data) => {
    return {
        type: GetAllThumbnail.GET_ALLTHUMBNAIL,
        payload: data
    }
}

export const getCompnaysitedata = (sitedata) => {
    return {
        type: CompanySitedetails.GET_COMPANYSITEDETAILS,
        payload: sitedata
    }
}